import React from "react";
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import imageSepa from './assets/images/sepa.png';
import imageCheque from './assets/images/cheque.png';
import imageVirement from './assets/images/virement.png';
import { Button, InputGroup, ToggleButton } from "react-bootstrap";

const Prix = ({ tarif, par, type, libelle, image }) => (
    <Card style={{ textAlign: "center", width: '18rem' }}>
        <Card.Img variant="top" src={image} style={{ width: "135px", margin: "auto", paddingTop: "10px" }} />
        <Card.Body>
            <Card.Title>{type}<br></br>{libelle}</Card.Title>
            <Card.Text>
                <Table style={{ margin: "auto", width: "auto" }}>
                    <thead style={{ textAlign: "start", borderColor: "transparent" }}>
                        <tr>
                            <td style={{ fontSize: "2.1em", fontWeight: "bold", paddingRight: "3px", width: "30px" }}>
                                {tarif}&nbsp;€
                            </td>
                            <td style={{ fontSize: "1em", fontWeight: "bold", paddingLeft: "0px", paddingTop: "15px", width: "30px", verticalAlign: "initial" }}>
                                HT
                            </td>
                            <td style={{ color: "gray", lineHeight: "16px", verticalAlign: "top", paddingTop: "17px", paddingLeft: "0px", width: "30px" }}>
                                <br></br>{par}
                            </td>
                        </tr>
                    </thead>
                </Table>
            </Card.Text>
        </Card.Body>
    </Card>
);



const TarifManuel = ({ adherentSel, reloadData }) => {
    // prix_tribu={adherentSel.tribu_montant} prix={adherentSel.montant} nb_fois={adherentSel.six_fois===1?6:(adherentSel.trois_fois===1?3:1)}
    const prix_tribu = adherentSel.tribu_montant;
    const prix = adherentSel.montant;
    const nb_fois = adherentSel.six_fois === 1 ? 6 : (adherentSel.trois_fois === 1 ? 3 : 1);

    const [montant, setMontant] = React.useState(prix);
    const [hasTribu, setHasTribu] = React.useState(false);
    const url = localStorage.getItem('url');

    const handleTarifSelected = (paiement, nb) => {
        //{paiement, nb, tribu: hasTribu}
        console.log('handleTarifSelected', paiement, nb);
        console.log('adherentSel', adherentSel);
        let body = {
            adherent_id: adherentSel.adherent_id, nb_fois: nb, has_tribu: hasTribu?1:0,
            montant_total: montant, montant_ffc: prix, montant_tribu: hasTribu ? prix_tribu : 0, type: paiement
        }
        console.log(body);
        if (window.confirm(`Êtes vous sûr de sélectionner ${paiement} en ${nb} fois ?`)) {
            fetch(`${url}SaveTarifManuel`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                // montant='" + dr["montant_total"].ToString() + "', montant_ffc='" + dr["choix_montant"].ToString() + "', 
                //montant_tribu='" + dr["tribu_montant_sel"].ToString() +
                // "', tribu='" + dr["has_tribu"].ToString() + "', somme_paid='" + dr["montant_total"].ToString() +
                // "', paid=" + paid + ", type='" + type + "' where code='" + code + "'");
                body: JSON.stringify(body)
            })
                .then(response => response.json())
                .then(data => {
                    // Traiter la réponse si nécessaire
                    console.log('Réponse du serveur:', data);
                    if (data === '0' || !data.status)
                        alert("rien à envoyer")
                    else {
                        console.log(data.data);
                        reloadData();
                    }
                })
                .catch(error => console.error('Erreur:', error));
        }
    }

    const handleTribuChange = (value) => {
        setHasTribu(value);
        if (value) {
            setMontant(prix + prix_tribu);
        } else {
            setMontant(prix);
        }
    }

    return (
        <Container>
            <Row>
                <Col style={{ textAlign: "-webkit-center" }}>
                    <InputGroup className="mb-3" width='100%'>
                        <InputGroup.Text>Accès à la cession de créance « TRIBU », l’assistance aux règlements et l’envoi de courriers via Clearbus au prix de {prix_tribu} €</InputGroup.Text>
                        <ToggleButton
                            id={"toggle-check-oui"}
                            type="checkbox"
                            variant={hasTribu ? 'success' : 'outline-success'}  // 'light' pour la variante "Non"
                            checked={hasTribu}
                            onChange={(e) => handleTribuChange(true)}
                        >
                            Oui
                        </ToggleButton>

                        <ToggleButton
                            id={"toggle-check-non"}
                            type="checkbox"
                            variant={!hasTribu ? 'danger' : 'outline-danger'}  // 'light' pour la variante "Oui"
                            checked={!hasTribu}
                            onChange={(e) => handleTribuChange(false)}
                        >
                            Non
                        </ToggleButton>
                    </InputGroup>
                </Col>
                <Col style={{ textAlign: "-webkit-center" }}>
                    <Button variant="primary" onClick={() => handleTarifSelected('PRELEVEMENT', 1)}>
                        <Prix tarif={montant} par="" type="Prélèvement SEPA" libelle="" lien="semestre" image={imageSepa}></Prix>
                    </Button>
                </Col>
                {nb_fois === 3 && <Col style={{ textAlign: "-webkit-center" }}>
                    <Button variant="primary" onClick={() => handleTarifSelected('PRELEVEMENT', 3)}>
                        <Prix tarif={montant} par="" type="Prélèvement SEPA" libelle="en 3 fois" lien="semestre" image={imageSepa}></Prix>
                    </Button>
                </Col>}
                {nb_fois === 6 && <Col style={{ textAlign: "-webkit-center" }}>
                    <Button variant="primary" onClick={() => handleTarifSelected('PRELEVEMENT', 6)}>
                        <Prix tarif={montant} par="" type="Prélèvement SEPA" libelle="en 6 fois" lien="semestre" image={imageSepa}></Prix>
                    </Button>
                </Col>}

                <Col style={{ textAlign: "-webkit-center" }}>
                    <Button variant="primary" onClick={() => handleTarifSelected('VIREMENT', 1)}>
                        <Prix tarif={montant} par="" type="Virement" libelle="" lien="annee" image={imageVirement}></Prix>
                    </Button>
                </Col>

                <Col style={{ textAlign: "-webkit-center" }}>
                    <Button variant="primary" onClick={() => handleTarifSelected('CHEQUE', 1)}>
                        <Prix tarif={montant} par="" type="Cheque" libelle="" lien="annee" image={imageCheque}></Prix>
                    </Button>
                </Col>
            </Row>
        </Container>
    );
}

export default TarifManuel;